import { Image, ScrollView, StyleSheet, TouchableOpacity, View } from "react-native";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { getAIChatHistory, postAiChat } from "appRedux/reducers/chatSlice";
import { useRef, useState } from "react";

import { ActivityIndicator } from "react-native";
import Buttons from "components/Buttons";
import ChatCarouselCop from "./chatCarouselCop";
import ChatCarouselProductCop from "./chatCarouselProductCop";
import { Colors } from "colors";
import DownloadAppModal from "./downloadAppModal";
import { Images } from "assets";
import Input from "components/Input";
import JumpingDots from "./typingDots";
import OutfitProductsModal from "./outfitProductsModal";
import { Svg } from "assets/svg";
import UploadImageModal from "./uploadImageModal";
import VText from "components/VText";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useRouter } from "expo-router";
import ChatEmptyView from "./chatEmptyView";
import ChatInputComponent from "./chatInputComponent";
import WelcomeModal from "./welcomeModal";
import ExploreLookCommonModal from "./ExploreTheLookCommonModal/ExploreLookCommonModal";
import SimilarProducts from "./similarProducts";
import SuccessToster from "./ExploreTheLookCommonModal/successToster";
let promentLimit = 3;

const SearchView = () => {
    const _videoRef = useRef();
    const scrollViewRef = useRef();
    const dispatch = useDispatch();
    const _downloadAppRef = useRef();
    const _outfitProductsModalRef = useRef();
    const _uploadImageModalRef = useRef();
    const _welcomeModalRef = useRef();
    const _exploreLookCommonModalRef = useRef();
    const _similarProductsRef = useRef();
    const _successTosterRef = useRef();
    const [chatHistory, setChatHistory] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [data, setData] = useState([
        { image: Images.mensOutfitLogin1 },
        { image: Images.mensOutfitLogin2 },
        { image: Images.mensOutfitLogin3 },
        { image: Images.mensOutfitLogin4 },
        { image: Images.mensOutfitLogin5 },
        { image: Images.mensOutfitLogin6 },
    ]);
    const [isTyping, setIsTyping] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [handleCarouselIndex, setHandleCarouselIndex] = useState([]);
    const [promentCount, setPromentCount] = useState(0);
    const router = useRouter();
    const carouselRefs = useRef([]);
    const [imageUrl, setImageUrl] = useState("");
    const [imageSelected, setImageSelected] = useState("");
    const [isMicRecording, setIsMicRecording] = useState(false);
    const [isTranscript, setIsTranscript] = useState(false);
    const [showWelcomeModal, setShowWelcomeModal] = useState(false);
    const [similarProduct, setSimilarProduct] = useState(null);

    useEffect(() => {}, [carouselRefs]);

    useEffect(() => {
        dispatch(getAIChatHistory({ pageNo: 1 }))
            .then((res) => {
                setIsLoading(false);
                let reverseData = [...res?.payload?.data];
                reverseData.reverse();
                setChatHistory(reverseData);
                scrollViewRef?.current?.scrollToEnd();

                const count = reverseData.filter((item) => item?.by === "user" && item?.platform === "web").length;
                setPromentCount(count);

                if (count >= promentLimit) {
                    _downloadAppRef?.current?.show();
                } else {
                    // Show welcome modal after 700ms if chat history exists
                    if (reverseData.length > 0) {
                        setTimeout(() => {
                            _welcomeModalRef?.current?.show();
                        }, 700);
                    }
                }
            })
            .catch((err) => {
                console.log("err--", err);
            });
        setTimeout(() => {
            _successTosterRef?.current?.show();
        }, 1500);
    }, []);

    useEffect(() => {
        scrollViewRef?.current?.scrollToEnd();
    }, [chatHistory]);

    const handleSendMessage = (inputValProp = "") => {
        if (promentCount >= promentLimit) {
            _downloadAppRef?.current?.show();
            return;
        }
        scrollViewRef?.current?.scrollToEnd();
        setIsTyping(true);
        setChatHistory([
            ...chatHistory,
            { message: inputValue || inputValProp, by: "user", createdDate: new Date(), imageUrl: imageUrl },
        ]);

        let data = [{ message: inputValue || inputValProp, by: "user", createdDate: new Date(), imageUrl: imageUrl }];
        setInputValue("");
        setImageUrl("");
        dispatch(postAiChat(data))
            .then((res) => {
                setChatHistory([
                    ...chatHistory,
                    { message: inputValue || inputValProp, by: "user", createdDate: new Date(), imageUrl: imageUrl },
                    {
                        ...res?.payload?.data,
                        by: "assistant",
                        createdDate: new Date(),
                        showProductsSlider: true,
                        productsData: res?.payload?.data?.products,
                    },
                ]);
                setIsTyping(false);

                if (promentCount == promentLimit) {
                    _downloadAppRef?.current?.show();
                }
                setPromentCount(promentCount + 1);
                scrollViewRef?.current?.scrollToEnd({ xoffset: 8000 });
            })
            .catch((err) => {
                console.log("err", err);
            })
            .finally(() => {
                setInputValue("");
            });
    };

    const redirectToProduct = (product) => {
        window.open(
            `/product?id=${product?.id}&brand=${product?.brandName}&product=${product?.productName}&gender=${product?.gender}`,
            "_blank"
        );
    };

    const showOutfitModal = (data) => {
        setSelectedProducts(data);
        _outfitProductsModalRef?.current?.show();
    };

    const handleDownloadApp = () => {
        _downloadAppRef?.current?.show();
    };

    const handleSimilarProducts = (product) => {
        setSimilarProduct(product);
        _similarProductsRef?.current?.show();
    };

    const handleMicPress = () => {
        setIsMicRecording(true);

        if (navigator?.mediaDevices && navigator?.mediaDevices?.getUserMedia) {
            navigator?.mediaDevices
                ?.getUserMedia({ audio: true })
                .then((stream) => {
                    const mediaRecorder = new MediaRecorder(stream);
                    mediaRecorder.start();
                    const speechRecognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
                    speechRecognition.start();
                    speechRecognition.onresult = (event) => {
                        mediaRecorder.stop();
                        setIsMicRecording(false);
                        const transcript = event.results[0][0].transcript;
                        setInputValue(transcript);
                        setIsTranscript(true);
                    };
                    speechRecognition.onerror = (event) => {
                        console.error("Speech recognition error:", event.error);
                    };
                    const audioChunks = [];
                    mediaRecorder.addEventListener("dataavailable", (event) => {
                        audioChunks.push(event.data);
                    });

                    mediaRecorder.addEventListener("stop", () => {
                        setIsMicRecording(false);
                    });

                    setTimeout(() => {
                        mediaRecorder.stop();
                        setIsMicRecording(false);
                    }, 6000); // Stop recording after 5 seconds
                })
                .catch((error) => {
                    setIsMicRecording(false);
                    console.error("Error accessing the microphone", error);
                });
        } else {
            setIsMicRecording(false);
            console.error("getUserMedia not supported on this browser!");
        }
    };

    const handleCameraPress = () => {
        setInputValue("Find and shop a product from a picture");
        _uploadImageModalRef?.current?.show();
    };

    const onImageSelected = (image) => {
        setImageUrl(image);
    };

    const closeWelcomeModal = () => {
        _welcomeModalRef?.current?.hide();
    };

    return (
        <View style={{ alignItems: "center" }}>
            <VText style={styles.title}>Ask Our AI Stylist</VText>

            {isLoading && <ActivityIndicator size="large" color={Colors.primary} style={{ marginTop: spV(30) }} />}

            {!isLoading && (
                <View style={{ justifyContent: "center", alignItems: "center", width: wp(1000) }}>
                    <ScrollView
                        contentOffset={{ x: 8000 }}
                        onLayout={() => scrollViewRef.current.scrollToEnd()}
                        ref={scrollViewRef}
                        style={{ maxHeight: hp(500), minHeight: hp(300), width: wp(1000), overflow: "scroll" }}
                    >
                        {chatHistory.length === 0 && (
                            <ChatEmptyView
                                onOptionPress={(text) => {
                                    setInputValue(text);
                                    setTimeout(() => {
                                        handleSendMessage(text);
                                    }, 200);
                                }}
                                onCameraPress={handleCameraPress}
                            />
                        )}

                        {chatHistory.length > 0 &&
                            chatHistory.map((item, index) => {
                                switch (item?.by) {
                                    case "user":
                                        return (
                                            <View style={{ alignItems: "flex-end", width: "100%" }}>
                                                {item?.imageUrl && (
                                                    <View
                                                        style={{
                                                            backgroundColor: "#21242799",
                                                            padding: spH(10),
                                                            borderRadius: fp(10),
                                                            marginVertical: spV(10),
                                                        }}
                                                    >
                                                        <Image
                                                            accessibilityLabel="User Message Image"
                                                            source={{ uri: item?.imageUrl }}
                                                            style={{ width: wp(70), height: hp(100) }}
                                                        />
                                                    </View>
                                                )}

                                                {item?.message && (
                                                    <VText style={styles.userMessage}>{item?.message}</VText>
                                                )}

                                                <VText
                                                    style={{ fontSize: fp(10), fontWeight: "300", color: "#888888" }}
                                                >
                                                    {new Date(item?.createdDate).toLocaleTimeString("en-US", {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                    }) +
                                                        ", " +
                                                        new Date(item?.createdDate).toLocaleDateString("en-US", {
                                                            day: "2-digit",
                                                            month: "short",
                                                        })}
                                                </VText>
                                            </View>
                                        );

                                    case "assistant":
                                        return (
                                            <>
                                                {/* Text Message */}
                                                <View style={{ alignItems: "flex-start", width: "100%" }}>
                                                    <View
                                                        style={{
                                                            flexDirection: "row",
                                                            alignItems: "center",
                                                            gap: spH(10),
                                                        }}
                                                    >
                                                        <Image
                                                            accessibilityLabel="AI Logo"
                                                            source={Svg.aiLogo}
                                                            style={{
                                                                width: wp(20),
                                                                height: hp(20),
                                                                alignSelf: "flex-start",
                                                                marginTop: spV(15),
                                                            }}
                                                        />
                                                        <View style={styles.AIMessage}>
                                                            <VText
                                                                style={{
                                                                    fontSize: fp(16),
                                                                    fontWeight: "300",
                                                                    lineHeight: fp(20),
                                                                }}
                                                            >
                                                                {item?.message}
                                                            </VText>
                                                        </View>
                                                    </View>
                                                    <VText
                                                        style={{
                                                            fontSize: fp(10),
                                                            fontWeight: "300",
                                                            color: "#888888",
                                                            marginLeft: spH(40),
                                                        }}
                                                    >
                                                        {new Date(item?.createdDate).toLocaleTimeString("en-US", {
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                        }) +
                                                            ", " +
                                                            new Date(item?.createdDate).toLocaleDateString("en-US", {
                                                                day: "2-digit",
                                                                month: "short",
                                                            })}
                                                    </VText>
                                                </View>
                                                {/* Products Slider */}

                                                {item.products && item?.products?.length > 0 && (
                                                    <View
                                                        style={{
                                                            alignItems: "flex-start",
                                                            width: "100%",
                                                            display: `${item?.outfits?.length > 0 ? "none" : ""}`,
                                                        }}
                                                    >
                                                        <View
                                                            style={{
                                                                flexDirection: "row",
                                                                alignItems: "center",
                                                                gap: spH(10),
                                                            }}
                                                        >
                                                            <Image
                                                                accessibilityLabel="AI Logo"
                                                                source={Svg.aiLogo}
                                                                style={{
                                                                    width: wp(20),
                                                                    height: hp(20),
                                                                    alignSelf: "flex-start",
                                                                    marginTop: spV(15),
                                                                }}
                                                            />
                                                            <View style={styles.AIMessage}>
                                                                <ChatCarouselProductCop
                                                                    data={item?.products}
                                                                    handleRedirect={redirectToProduct}
                                                                    handleSimilarProducts={handleSimilarProducts}
                                                                />
                                                            </View>
                                                        </View>
                                                        <VText
                                                            style={{
                                                                fontSize: fp(10),
                                                                fontWeight: "300",
                                                                color: "#888888",
                                                                marginLeft: spH(40),
                                                            }}
                                                        >
                                                            {new Date(item?.createdDate).toLocaleTimeString("en-US", {
                                                                hour: "2-digit",
                                                                minute: "2-digit",
                                                            }) +
                                                                ", " +
                                                                new Date(item?.createdDate).toLocaleDateString(
                                                                    "en-US",
                                                                    {
                                                                        day: "2-digit",
                                                                        month: "short",
                                                                    }
                                                                )}
                                                        </VText>
                                                    </View>
                                                )}

                                                {/* Outfit Slider */}
                                                {item?.outfits?.length > 0 && (
                                                    <View style={{ alignItems: "flex-start", width: "100%" }}>
                                                        <View
                                                            style={{
                                                                flexDirection: "row",
                                                                alignItems: "center",
                                                                gap: spH(10),
                                                            }}
                                                        >
                                                            <Image
                                                                accessibilityLabel="AI Logo"
                                                                source={Svg.aiLogo}
                                                                style={{
                                                                    width: wp(20),
                                                                    height: hp(20),
                                                                    alignSelf: "flex-start",
                                                                    marginTop: spV(15),
                                                                }}
                                                            />
                                                            <View style={styles.AIMessage}>
                                                                <ChatCarouselCop
                                                                    _exploreLookCommonModalRef={
                                                                        _exploreLookCommonModalRef
                                                                    }
                                                                    data={item?.outfits}
                                                                    buttonText="Shop Product"
                                                                    handleRedirect={showOutfitModal}
                                                                />
                                                            </View>
                                                        </View>
                                                        <VText
                                                            style={{
                                                                fontSize: fp(10),
                                                                fontWeight: "300",
                                                                color: "#888888",
                                                                marginLeft: spH(40),
                                                            }}
                                                        >
                                                            {new Date(item?.createdDate).toLocaleTimeString("en-US", {
                                                                hour: "2-digit",
                                                                minute: "2-digit",
                                                            }) +
                                                                ", " +
                                                                new Date(item?.createdDate).toLocaleDateString(
                                                                    "en-US",
                                                                    {
                                                                        day: "2-digit",
                                                                        month: "short",
                                                                    }
                                                                )}
                                                        </VText>
                                                    </View>
                                                )}
                                            </>
                                        );
                                }
                            })}

                        {isTyping && (
                            <View style={{ alignItems: "flex-start", width: "100%" }}>
                                <View style={{ flexDirection: "row", alignItems: "center", gap: spH(10) }}>
                                    <Image
                                        accessibilityLabel="AI Logo"
                                        source={Svg.aiLogo}
                                        style={{
                                            width: wp(20),
                                            height: hp(20),
                                            alignSelf: "flex-start",
                                            marginTop: spV(15),
                                        }}
                                    />
                                    <View>
                                        <View
                                            style={{
                                                flexDirection: "row",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                height: hp(50),
                                            }}
                                        >
                                            <JumpingDots />
                                        </View>
                                    </View>
                                </View>
                            </View>
                        )}
                    </ScrollView>

                    <ChatInputComponent
                        inputValue={inputValue}
                        setInputValue={setInputValue}
                        handleSendMessage={handleSendMessage}
                        promentCount={promentCount}
                        isMicRecording={isMicRecording}
                        isTranscript={isTranscript}
                        setIsTranscript={setIsTranscript}
                        handleMicPress={handleMicPress}
                        imageUrl={imageUrl}
                        setImageUrl={setImageUrl}
                        handleCameraPress={handleCameraPress}
                        handleDownloadApp={handleDownloadApp}
                        setIsTyping={setIsTyping}
                    />
                </View>
            )}

            <DownloadAppModal ref={_downloadAppRef} />
            <OutfitProductsModal ref={_outfitProductsModalRef} productsData={selectedProducts} />
            <UploadImageModal ref={_uploadImageModalRef} onImageSelected={onImageSelected} />
            <ExploreLookCommonModal ref={_exploreLookCommonModalRef} />
            <WelcomeModal
                ref={_welcomeModalRef}
                inputValue={inputValue}
                optionPress={(text) => {
                    handleSendMessage(text);
                    closeWelcomeModal();
                }}
                setInputValue={setInputValue}
                promentCount={promentCount}
                isMicRecording={isMicRecording}
                isTranscript={isTranscript}
                setIsTranscript={setIsTranscript}
                handleMicPress={() => {
                    handleMicPress();
                    closeWelcomeModal();
                }}
                imageUrl={imageUrl}
                setImageUrl={setImageUrl}
                handleCameraPress={() => {
                    handleCameraPress();
                    closeWelcomeModal();
                }}
                handleDownloadApp={() => {
                    handleDownloadApp();
                    closeWelcomeModal();
                }}
                setIsTyping={setIsTyping}
                onClose={closeWelcomeModal}
                onCameraPress={() => {
                    handleCameraPress();
                    closeWelcomeModal();
                }}
                onMicPress={() => {
                    handleMicPress();
                    closeWelcomeModal();
                }}
                handleSendMessage={() => {
                    handleSendMessage();
                    closeWelcomeModal();
                }}
            />
          
            <SimilarProducts ref={_similarProductsRef} product={similarProduct} />
        </View>
    );
};

const styles = StyleSheet.create({
    title: {
        alignSelf: "center",
        marginTop: spV(32),
        fontFamily: "LibreBodoni",
        fontSize: fp(28),
        fontWeight: "300",
    },
    userMessage: {
        fontSize: fp(16),
        fontWeight: "300",
        marginVertical: spV(10),
        alignItems: "right",
        backgroundColor: "#21242799",
        padding: spH(10),
        color: "white",
        borderRadius: fp(20),
    },
    AIMessage: {
        marginVertical: spV(10),
        borderWidth: 1,
        borderColor: "#E7E7E7",
        borderRadius: fp(20),
        padding: spH(20),
        width: wp(745),
        overflow: "hidden",
    },
    button: {
        width: wp(280),
        height: hp(36),
        borderRadius: fp(1),
        backgroundColor: "#D8D8D8",
    },
    buttonText: {
        color: "black",
        fontSize: fp(16),
        fontWeight: "350",
    },
});

export default SearchView;
